import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaInfoCircle } from 'react-icons/fa';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
    FormGroup,
    Form,
    Container
} from 'react-bootstrap';
import cx from 'classnames';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//Components
import messages from '../../../../../locale/messages';
import DateRangePicker from '../../../../Common/DateRangePicker/DateRangePicker';
import Loader from '../../../../Common/Loader/Loader';
import validate from './validate';
import submit from './submit';
import s from './CompleteOrderPDFForm.css'
class CompleteOrderPDFForm extends Component {
    static propTypes = {
        formatMessage: PropTypes.func,
        handleSubmit: PropTypes.func,
        isCompleletBookingPDFLoading: PropTypes.bool,
        submitting: PropTypes.bool
    }

    renderDateField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
        const { formatMessage } = this.props.intl;
        function LinkWithTooltip({ id, children, tooltip }) {
            return (
                <OverlayTrigger
                    overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
                    placement="bottom"
                    delayShow={300}
                    delayHide={150}
                >
                    <span>{children}</span>
                </OverlayTrigger>
            );
        }

        return (
            <FormGroup className='orderPDFDayPickerContainer'>
                <div className={s.labelFlex}>
                    <label> <FormattedMessage {...messages.dateRangeLabel} /></label>
                    <LinkWithTooltip
                        tooltip={formatMessage(messages.toolTipMsg)}
                        id="tooltip-1"
                    >
                        <span>
                            <FaInfoCircle />
                        </span>
                    </LinkWithTooltip>
                </div>
                <DateRangePicker
                    formName={"CompleteOrderPDFForm"}
                />
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { handleSubmit, isCompleletBookingPDFLoading, submitting } = this.props;

        return (
            <Container fluid className='mt12'>
                <Form onSubmit={handleSubmit(submit)}>
                    <Field name="date" component={this.renderDateField} />
                    <FormGroup>
                        <Loader
                            type={"button"}
                            buttonType={"submit"}
                            label={formatMessage(messages.downLoadPDFLabel)}
                            show={isCompleletBookingPDFLoading || submitting}
                            disabled={isCompleletBookingPDFLoading || submitting}
                            className={cx(s.button, s.btnPrimary, s.btnPadding, 'rtlBtnLoader')}
                            containerClass={'textEnd'}
                        />
                    </FormGroup>
                </Form>
            </Container>
        )
    }
};

CompleteOrderPDFForm = reduxForm({
    form: 'CompleteOrderPDFForm', // a unique name for this form,
    validate
})(CompleteOrderPDFForm);

const mapToState = state => ({
    isCompleletBookingPDFLoading: state.loader.isCompleletBookingPDFLoading
});

const mapToDispatch = {};

export default injectIntl(withStyles(s)(connect(mapToState, mapToDispatch)(CompleteOrderPDFForm)));